import { __ } from '@wordpress/i18n';

/**
 * The statuses a cue sheet item can take.
 *
 * These are the four values of `CueSheetStatus` in the API schema: anything
 * else is rejected with a 422 by `PUT .../cue-sheet/{id}` and by the bulk
 * endpoints, so the pickers are built from this list and nothing else.
 */
export const CUE_SHEET_STATUSES = ['to_work', 'assigned', 'working', 'done'];

export const CUE_SHEET_STATUS_LABELS = {
    to_work: __('Da lavorare', 'soundbetween'),
    assigned: __('Assegnato', 'soundbetween'),
    working: __('In lavorazione', 'soundbetween'),
    done: __('Completato', 'soundbetween'),
};

/**
 * Labels of values the UI has shown in the past — a cue sheet stored before the
 * enum was settled still carries them, so a row keeps reading correctly instead
 * of printing a raw key.
 */
const LEGACY_STATUS_LABELS = {
    in_progress: __('In lavorazione', 'soundbetween'),
    completed: __('Completato', 'soundbetween'),
    approved: __('Approvato', 'soundbetween'),
    to_review: __('Da rivedere', 'soundbetween'),
    to_assign: __('Da assegnare', 'soundbetween'),
    unassigned: __('Non assegnato', 'soundbetween'),
    pending: __('In attesa', 'soundbetween'),
};

export const getCueSheetStatusLabel = (status) =>
    CUE_SHEET_STATUS_LABELS[status] ?? LEGACY_STATUS_LABELS[status] ?? status;

/** Options for a `<select>`; the empty one means "leave the status alone". */
export const getCueSheetStatusOptions = (emptyLabel = '—') => ([
    { value: '', label: emptyLabel },
    ...CUE_SHEET_STATUSES.map(value => ({ value, label: CUE_SHEET_STATUS_LABELS[value] })),
]);
